import { useCallback } from "react";
import { Modal } from "react-overlays";
import Icon from "../icon";
import useEventCancelMutation from "../../hooks/mutations/useEventCancelMutation";

const renderBackdrop = (props) => <div className="backdrop" {...props} />;

const CancelEventBookingModal = ({
  show,
  setShow,
  labels,
  setCancelledToast,
  setEventNavigation,
  eventId,
  setReservation,
}) => {
  const closeModal = () => setShow(false);

  const {
    mutateAsync: cancelBooking,
    isError,
    isLoading,
  } = useEventCancelMutation(closeModal, setEventNavigation, setReservation);

  const handleCancelRequest = useCallback(async () => {
    await cancelBooking({ eventId });
    setCancelledToast(true);
  }, [cancelBooking, setCancelledToast, eventId]);

  return (
    <Modal
      show={show}
      onHide={closeModal}
      aria-labelledby="modal-label"
      className="modal modal--event dark-mode"
      renderBackdrop={renderBackdrop}
      onBackdropClick={closeModal}
      aria-hidden="false"
      aria-modal="true"
    >
      <>
        <button
          type="button"
          onClick={closeModal}
          className="close-button"
          aria-label={labels?.CLOSE}
        >
          <Icon name="cross" />
        </button>
        <div className="modal__body wrapper">
          <h1 className="modal__title">
            {labels?.EVENT_CANCEL_MODAL_TITLE || "Do you want to cancel your booking?"}
          </h1>
          {labels?.EVENT_CANCEL_MODAL_DESCR && (
            <p className="modal__description">{labels?.EVENT_CANCEL_MODAL_DESCR}</p>
          )}
          <div className="modal__buttons">
            <button className="button secondary" onClick={closeModal}>
              {labels?.EVENT_CANCEL_MODAL_SECONDARY || "No"}
            </button>
            <button className="button primary" onClick={handleCancelRequest}>
              {isLoading && <span className="loading-spinner" />}
              {labels?.EVENT_CANCEL_MODAL_PRIMARY || "Yes, cancel booking"}
              <Icon name="trash" />
            </button>
          </div>
          {isError && (
            <p className="modal__error">
              {labels?.EVENT_DELETING_MODAL_BOOKING || "Error deleting booking"}
            </p>
          )}
        </div>
      </>
    </Modal>
  );
};

export default CancelEventBookingModal;
